module.exports = __webpack_public_path__ + "static/icons/icon-heart-fill-ee52a9b13701462ccc8f4a28533378c2.svg";